import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { Arbitro } from '../../system/Arbitro/Arbitro';
import { ArbitroOfflineAssertions } from '../../system/PlanillaPartidoOffline/ArbitroOfflineAssertions';

class ArbitroOfflineForm extends CustomForm {
  protected constructor(
    arbo_id: string | null,
    arbo_tipo_doc: string,
    arbo_nro_doc: string,
    arbo_nombre: string,
    arbo_apellido: string
  ) {
    const arboff = ArbitroOfflineAssertions.build();
    super('ArbitroOffline', arboff);
    this.addInputAsserted('arbo_id', arbo_id);
    this.addInput('arbo_tipo_doc', arbo_tipo_doc);
    this.addInput('arbo_nro_doc', arbo_nro_doc);
    this.addInput('arbo_nombre', arbo_nombre);
    this.addInput('arbo_apellido', arbo_apellido);
  }

  private static build(
    arbo_id: string | null,
    arbo_tipo_doc: string,
    arbo_nro_doc: string,
    arbo_nombre: string,
    arbo_apellido: string
  ) {
    return new this(arbo_id, arbo_tipo_doc, arbo_nro_doc, arbo_nombre, arbo_apellido);
  }

  static initialize() {
    return this.build(null, '', '', '', '');
  }

  toArbitro(): Arbitro {
    return Arbitro.createFrom(
      this.getIdInput().getValue(),
      this.getNombreInput().getValue(),
      this.getApellidoInput().getValue(),
      this.getNroDocInput().getValue(),
      new Date(),
      '',
      '',
      '',
      '',
      0,
      '',
      '',
      '',
      true,
      0,
      '',
      [],
      [],
      [],
      this.getTipoDocInput().getValue()
    );
  }

  getIdInput() {
    return this.getInputByName('arbo_id');
  }

  getTipoDocInput() {
    return this.getInputByName('arbo_tipo_doc');
  }

  getNroDocInput() {
    return this.getInputByName('arbo_nro_doc');
  }

  getNombreInput() {
    return this.getInputByName('arbo_nombre');
  }

  getApellidoInput() {
    return this.getInputByName('arbo_apellido');
  }
}

export default ArbitroOfflineForm;
